import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by the Mahan Oven

export default function DancerArmTensionRow() {
   const { handleInputRangeChangeFloatIncremental } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={"Dancer Arm Tension"} bold={true} description={""} sizeProp={3} />
         <ColValue size={4}>
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.dancerArmTension || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChangeFloatIncremental(e, 1.0, 15.0, "dancerArmTension", 0.5, false)
                     : handleInputRangeChangeFloatIncremental(defaultOnChangeVal, 1.0, 15.0, "dancerArmTension", 0.5, false)
               }
            />
            {errorDivDefinitions.dancerArmTension && (
               <ErrorDiv>1-15 in 0.5 increments</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}